import { ApolloClient, useApolloClient } from '@apollo/client';
import { subscribe as subscribeBase, TConnectionItem } from '@chocolate-soup-inc/cs-api-consumer-utils';
import { useEffect } from 'react';
import { onSubscriptionData } from '../../config/apollo/cache';
import { GetMyCompanyDocument, OnCompanyChangedDocument, TGetMyCompanyQuery, TGetMyCompanyQueryVariables, TOnCompanyChangedSubscription, TOnCompanyChangedSubscriptionVariables } from '../../generated/graphql';

type TOnCompanySubscriptionDataProps = {
  client: ApolloClient<object>;
  data?: TOnCompanyChangedSubscription;
  vars?: TOnCompanyChangedSubscriptionVariables;
};

const onCompanySubscriptionData = async (props: TOnCompanySubscriptionDataProps) => {
  const { client, data, vars } = props;

  const { id, _deleted } = data?.onCompanyChanged || {};

  if (_deleted) return onSubscriptionData(data as Record<string, any>, vars);
  if (!id) return;

  const response = await client.query<TGetMyCompanyQuery, TGetMyCompanyQueryVariables>({
    query: GetMyCompanyDocument
  });

  const companyData = response.data.getMyCompany as TConnectionItem;

  if (companyData)
    return onSubscriptionData(
      {
        onCompanyChanged: companyData
      },
      vars
    );
};

type TUseSubscribeToCompanyChangedProps = {
  id?: string;
};

export const useSubscribeToCompanyChanged = (variables: TUseSubscribeToCompanyChangedProps) => {
  const client = useApolloClient();

  useEffect(() => {
    if (variables.id)
      subscribeBase({
        client,
        query: OnCompanyChangedDocument,
        variables,
        onSubscriptionData: async (data, vars) => {
          await onCompanySubscriptionData({
            client,
            data: data as TOnCompanyChangedSubscription,
            vars: vars as TOnCompanyChangedSubscriptionVariables
          });
        }
      });
  }, [client, variables, variables.id]);
};
